import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sz-bubble" }
const _hoisted_2 = { class: "f-18 sz-primary-grey--text mb-0 font-weight-medium" }

import { useVuetifyBreakpoints } from '@/composables/useVuetifyBreakpoints';
import type { RouteLocation } from 'vue-router';

type Props = {
    name?: string;
    link: RouteLocation;
    highlighted?: boolean;
    icon?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SzBubble',
  props: {
    name: { default: '' },
    link: {},
    highlighted: { type: Boolean, default: false },
    icon: { default: '$chevronRight' }
  },
  setup(__props: any) {



const breakpoints = useVuetifyBreakpoints();
const isMobile = breakpoints.smallerOrEqual('md');


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: _ctx.link,
      class: "disable-text-decoration"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_sheet, {
          elevation: _unref(isMobile) ? 0 : 4,
          class: _normalizeClass(["min-h-60 d-flex align-center justify-space-between px-5", {
          'v-sheet-orange-top': _ctx.highlighted && !_unref(isMobile), 'mobile-sheet': _unref(isMobile),
          'v-sheet-rounded': !_unref(isMobile), 'mobile-border': _unref(isMobile), 'mobile-border--highlighted': _unref(isMobile) && _ctx.highlighted,
        }])
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.name), 1),
            _createVNode(_component_v_icon, {
              class: _normalizeClass({ 'sz-primary-red--text': _ctx.highlighted })
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.icon), 1)
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        }, 8, ["elevation", "class"])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}
}

})